import client from '@libs/HttpClient';
class TaskService {
  static listTask(request) {
    const projectId = request.id;
    const page_no = request.page_no;
    const searchText = request.searchText;
    const selectedPriority = request.selectedPriority;
    const selectedAssignee = request.selectedAssignee;
    const selectedSprint = request.selectedSprint;
    const selectedSuspicious = request.selectedSuspicious;
    const selectedFilter = request.selectedFilter;
    const selectedInactiveUser = request.selectedInactiveUser;
    return client.get(
      `/projects/view/${projectId}/task?search=${searchText}&page=${page_no}&selectedPriority=${selectedPriority}&selectedAssignee=${selectedAssignee}&selectedSprint=${selectedSprint}&selectedSuspicious=${selectedSuspicious}&selectedFilter=${selectedFilter}&selectedInactiveUser=${selectedInactiveUser}`,
      request
    );
  }
  static deleteTask(projectId, id) {
    return client.delete(`/projects/view/${projectId}/task/${id}`);
  }
  static addTask(request) {
    const projectId = request.project_id;
    return client.post(`projects/view/${projectId}/task`, request);
  }
  static updateTask(request) {
    const id = request.id;
    const projectId = request.project_id;
    return client.put(`/projects/view/${projectId}/task/${id}`, request);
  }
  static viewTask(projectId, id) {
    return client.get(`/projects/view/${projectId}/task/${id}/edit`);
  }
  static showTask(projectId, id) {
    return client.get(`/projects/view/${projectId}/task/${id}`);
  }
  static getSprintList(projectId) {
    return client.get(`/get-active-sprint-list/${projectId}`);
  }
  static getTaskPriorities() {
    return client.get(`/get-task-priorities`);
  }
  static getTaskStatusTypes(projectId) {
    return client.get(`/get-project-task-status-types/${projectId}`);
  }
  static getTaskDetails(projectId, id) {
    return client.get(`/projects/view/${projectId}/task/${id}/details`);
  }
  static getAssignedProjectEmployeeList(projectId, status = 0) {
    return client.get(`/get-project-assigned-project-employee-list/${projectId}?status=${status}`);
  }
  static getProjectRemovedInactiveProjectEmployeeList(projectId, viewType) {
    return client.get(`/get-project-removed-inactive-project-employee-list/${projectId}?viewType=${viewType}`);
  }
  static getProjectRemovedInactiveHistoryEmployeeList(projectId) {
    return client.get(`/projects/view/${projectId}/all-inactive-employees`);
  }
  static updateTaskAssignees(request) {
    const id = request.id;
    const projectId = request.project_id;
    return client.put(`/projects/view/${projectId}/task/${id}/update-assignee`, request);
  }
  static getTaskStatusTypesWithSubTasks(request) {
    const projectId = request.id;
    const searchText = request.searchText;
    const selectedPriority = request.selectedPriority;
    const selectedAssignee = request.selectedAssignee;
    const selectedSprint = request.selectedSprint;
    const selectedSuspicious = request.selectedSuspicious;
    const selectedFilter = request.selectedFilter;
    const selectedInactiveUser = request.selectedInactiveUser;
    return client.get(`/get-project-task-status-types-with-sub-tasks/${projectId}?search=${searchText}&selectedPriority=${selectedPriority}&selectedAssignee=${selectedAssignee}&selectedSprint=${selectedSprint}&selectedSuspicious=${selectedSuspicious}&selectedFilter=${selectedFilter}&selectedInactiveUser=${selectedInactiveUser}`);
  }
  static updateTaskStatus(request) {
    const projectId = request.project_id;
    const taskId = request.task_id;
    return client.put(`/projects/view/${projectId}/task/${taskId}/update-task-status`, request);
  }
  static updateTaskPriority(request) {
    const projectId = request.project_id;
    const taskId = request.task_id;
    return client.put(`/projects/view/${projectId}/task/${taskId}/update-task-priority`, request);
  }
  static getAssignedProjectEmployeeAdminList(projectId, status = 0) {
    return client.get(`/get-project-assigned-project-admin-employee-list/${projectId}?status=${status}`);
  }
}
export { TaskService };
